import React, { useState, useEffect, useContext } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Fade,
  Backdrop
} from '@mui/material';
import { ReviewContext } from '../ReviewContext';
import { showSwalNotification } from '../../utils/SwalResponse';

const UpdateReplyModal = ({  reload, setReload, currentReply,review }) => {
  const {updateReply} = useContext(ReviewContext)
  const [updatedText, setUpdatedText] = useState('');
  const [error, setError] = useState(null)
      const [open, setOpen] = useState(false);
      const handleOpen = () => setOpen(true);
      const handleClose = () => setOpen(false);

  useEffect(() => {
    if (currentReply) {
      setUpdatedText(currentReply);
    }
  }, [currentReply]);

  const handleUpdate = async () => {
    if (updatedText.trim()) {
      // console.log({reply_text:updatedText, reply_id:review?.reply?.reply_id})
      const response = await updateReply({reply_text:updatedText, reply_id:review?.reply?.reply_id});
      if (response?.status === 'success'){

        handleClose();
        showSwalNotification(response);
        setError(null)
        setReload(!reload)
      } else {
        setError(`${response?.status || 'Error'}: ${response?.message || 'Something went wrong.'}`);
      }
    }
  };

  return (
    <>
    <Button
        size="small"
        onClick={handleOpen}
        sx={{
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { textDecoration: "underline" },
        }}
    >
      🔃 Edit Reply
    </Button>
    <Modal
    open={open}
    onClose={handleClose}
    closeAfterTransition
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        timeout: 300,
      },
    }}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }} // <-- This ensures perfect vertical & horizontal centering
  >
    <Fade in={open}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          width: '90%',
          maxWidth: 500,
          outline: 'none',
          position: 'absolute',
        }}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      >
          <Typography variant="h6" className="mb-3 fw-bold text-success">
            Update Reply to {review?.user?.name}
          </Typography>
          <TextField
            label="Updated Reply"
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            value={updatedText}
            onChange={(e) => setUpdatedText(e.target.value)}
          />
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box className="mt-4 d-flex justify-content-end gap-2">
            <Button onClick={handleClose} variant="outlined" color="error">
              Cancel
            </Button>
            <Button onClick={handleUpdate} variant="contained" color="success">
              Save Changes
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
    </>
  );
};

export default UpdateReplyModal;
